export enum CoreWebhookVersion {
  V1 = 'v1',
  V2 = 'v2',
}

// Webhook data returned by GET /v2/webhooks
export type CoreWebhook = {
  id: string;
  name: string;
  description: string | null;
  endpoint: string;
  version: CoreWebhookVersion;
  headers: { [key: string]: string };
  enabled: boolean;
};
